/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
// import Hotjar from '@hotjar/browser'
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useDispatch } from "react-redux";
import { setOrgSettings } from "data/store/reducers/org-settings";
import { useAuth } from "cms/auth/hooks/use-auth";


const CustomerBranding = () => {

    const [settings, setSettings] = useState(false);
    // const [analyticsInitialized, setAnalyticsInitialized] = useState(false)

    const dispatch = useDispatch();
    const { token = "" } = useAuth();

    useEffect(() => {
        const run = async () => {
            if (!settings) {
                const settings = await SimpliCityAdminSDK.orgSettings.find(token);
                setSettings(settings);
                // if (!analyticsInitialized) {
                //     const analyticsConf = {
                //         siteId: settings.hotjar_siteid,
                //         hotjarVersion: settings.hotjar_version,
                //     }
                //     Hotjar.init(analyticsConf.siteId, analyticsConf.hotjarVersion)
                //     setAnalyticsInitialized(true)
                // }
                // Logger.debug(`Settings loaded.`,settings)
                dispatch(setOrgSettings(settings));
            }
        };
        run();
    }, [dispatch, settings, token]);


    return (
        <div className='brand-logo-container'>
            {settings?.brand_logo &&
                <>
                    <img
                        src={settings?.brand_logo}
                        alt={settings?.brand_name}
                        className='brand_logo'
                    />
                </>
            }
            {/*  this space expands to take up space in the bar  */}
            <div className='brand_name'>
                {settings?.brand_name}
            </div>
        </div>
    );
};

export { CustomerBranding };
